import { DashboardContainer } from "@containers"

const DashboardPage = () => {
  return <DashboardContainer />
}

export default DashboardPage
